const childrenLoaded = require('@alexspirgel/children-loaded');
import Player from '@vimeo/player';

class HeroVideo extends HTMLElement {
    constructor() {
        super();
    }

    pauseCurrentSlideVideo = (Slide) => {
        const currentSlide = Slide.slide;
        const video = currentSlide.querySelector('video');
        const iframe = currentSlide.querySelector('iframe');

        if (video) {
            video.pause();
            currentSlide.classList.remove('video-played');
        }

        if (iframe && iframe.src.includes('vimeo')) {
            new Vimeo.Player(iframe).pause();
        }

        if (iframe && iframe.src.includes('youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        }
    };

    isMobile() {
        return typeof Screen.orientation !== "undefined" || navigator.userAgent.indexOf('Mobi') !== -1;
    }

    setUrlParams(iframeSrc, videoId) {
        const url = new URL(iframeSrc);

        if (!this.isMobile()) {
            url.searchParams.set('autoplay', '1');
        }

        url.searchParams.set('controls', '0');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('loop', '1');

        if (iframeSrc.includes('vimeo')) {
            url.searchParams.set('title', '0');
            url.searchParams.set('byline', '0');
            url.searchParams.set('sidedock', '0');
            url.searchParams.set('muted', '1')
            url.searchParams.set('keyboard', '0')
        } else {
            url.searchParams.set('muted', '1');
            url.searchParams.set('mute', '1');
            url.searchParams.set('enablejsapi', '1');
            url.searchParams.set('modestbranding', '0');
            url.searchParams.set('rel', '0');
            url.searchParams.set('playlist', videoId);
        }
        return url.toString();
    }

    setPlayedState(playerControlContainer) {
        playerControlContainer.setAttribute('data-is-played', 'true');
    }

    async connectedCallback() {
        await childrenLoaded(this);
        const iframe = this.querySelector('iframe');
        const video = this.querySelector('video');
        const videoContainer = this.querySelector('.home-page-hero__image');
        const playerControlContainer = videoContainer.querySelector('.home-page-hero__player-container');

        if (video) {
            video.addEventListener('canplay', () => {
                video.play();
                this.setPlayedState(playerControlContainer);
            });
        }

        if (this.getAttribute('data-is-preview') === "1") {
            return
        }

        if (iframe) {
            const videoId = new URL(videoContainer.getAttribute('data-src')).searchParams.get('v');
            const url = this.setUrlParams(videoContainer.getAttribute('src'), videoId);
            iframe.setAttribute('src', url.toString());
            iframe.setAttribute('allow', 'autoplay');
        }

        if (!this.isMobile()) {
            this.setPlayedState(playerControlContainer);
        }

        const that = this;
        this.querySelectorAll('.home-page-hero__video-control').forEach(function (videoControl) {
            videoControl.addEventListener('click', function (e) {
                e.stopPropagation()
                const iframe = videoContainer.querySelector('iframe');
                const video = videoContainer.querySelector('video');

                if (videoControl.matches('button.play-button')) {
                    if (iframe && iframe.src.includes('vimeo')) {
                        new Player(iframe).play();
                    } else if (iframe && iframe.src.includes('youtube')) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                    }

                    if (video) {
                        video.play();
                    }

                    that.setPlayedState(playerControlContainer);
                }

                if (videoControl.matches('button.pause-button')) {
                    if (iframe && iframe.src.includes('vimeo')) {
                        new Player(iframe).pause();
                    } else if (iframe && iframe.src.includes('youtube')) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                    }

                    if (video) {
                        video.pause();
                    }
                    playerControlContainer.setAttribute('data-is-played', 'false');
                }
            });
        });
    }
}

customElements.define('hero-banner', HeroVideo, {extends: 'section'});
